"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Home = Home;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

function Home(props) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: "56",
    height: "12",
    viewBox: "0 0 56 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _core.jsx)("path", {
    d: "M7.72565 0.149378H10.6971V11.8506H7.72565V7.12033H2.9714V11.8506H0V0.149378H2.9714V4.6971H7.72565V0.149378Z",
    fill: "currentColor"
  }), (0, _core.jsx)("path", {
    d: "M20.9725 12C19.7839 12 18.7494 11.7566 17.869 11.2697C16.9996 10.7718 16.3283 10.0747 15.8551 9.17842C15.3818 8.27109 15.1452 7.20885 15.1452 5.9917C15.1452 4.77455 15.3818 3.71784 15.8551 2.82158C16.3283 1.91425 16.9996 1.21715 17.869 0.730291C18.7494 0.24343 19.7839 0 20.9725 0C22.161 0 23.19 0.24343 24.0594 0.730291C24.9398 1.21715 25.6112 1.91425 26.0734 2.82158C26.5466 3.71784 26.7832 4.77455 26.7832 5.9917C26.7832 7.20885 26.5466 8.27109 26.0734 9.17842C25.6002 10.0747 24.9233 10.7718 24.0429 11.2697C23.1735 11.7566 22.15 12 20.9725 12ZM20.9725 9.65975C21.8529 9.65975 22.5407 9.34993 23.0359 8.73029C23.5312 8.09959 23.7788 7.18672 23.7788 5.9917C23.7788 4.79668 23.5257 3.88935 23.0194 3.26971C22.5242 2.65007 21.8419 2.34025 20.9725 2.34025C20.0921 2.34025 19.4042 2.65007 18.909 3.26971C18.4138 3.87829 18.1661 4.78562 18.1661 5.9917C18.1661 7.19779 18.4138 8.11065 18.909 8.73029C19.4042 9.34993 20.0921 9.65975 20.9725 9.65975Z",
    fill: "currentColor"
  }), (0, _core.jsx)("path", {
    d: "M40.6166 0.149378H42.9607V11.8506H40.3194V5.70954L38.0744 9.90871H36.1265L33.8979 5.80913L33.8814 11.8506H31.2401V0.149378H33.6338L37.1334 6.80498L40.6166 0.149378Z",
    fill: "currentColor"
  }), (0, _core.jsx)("path", {
    d: "M47.7296 11.8506V0.149378H56V2.50622H50.6845V4.73029H55.6698V7.07054H50.6845V9.49378H56V11.8506H47.7296Z",
    fill: "currentColor"
  }));
}

Home.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Home"
};